// This file is auto-generated by scripts/generate-form-schema.ts
// DO NOT EDIT MANUALLY - run 'pnpm generate-schema' to regenerate

export type StaticFieldSchema = {
  key: string
  type: 'string' | 'number' | 'boolean' | 'object' | 'array' | 'enum'
  required: boolean
  component:
    | 'TextInput'
    | 'Select'
    | 'Checkbox'
    | 'Textarea'
    | 'NumberInput'
    | 'ArrayEditor'
  numberFormat?: 'integer' | 'float' | 'currency'
  options?:
    | Array<string>
    | Array<{ label: string; value: string; sublabel?: string }>
  nested?: Array<StaticFieldSchema>
  fullPath?: string
  description?: string
  /** The spec marks this field readOnly, so no request body may carry it. */
  readOnly?: boolean
}

export const employeesUpdateRequestSchema: Array<StaticFieldSchema> = [
  {
    key: 'id',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'id',
    readOnly: true,
  },
  {
    key: 'createdAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'createdAt',
    readOnly: true,
  },
  {
    key: 'updatedAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'updatedAt',
    readOnly: true,
  },
  {
    key: 'deletedAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'deletedAt',
    readOnly: true,
  },
  {
    key: 'firstName',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'firstName',
  },
  {
    key: 'lastName',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'lastName',
  },
  {
    key: 'object',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'object',
    options: ['Employee'],
    readOnly: true,
  },
  {
    key: 'companyId',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'companyId',
    readOnly: true,
  },
  {
    key: 'user',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'user',
    nested: [
      {
        key: 'id',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'user.id',
        readOnly: true,
      },
      {
        key: 'createdAt',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'user.createdAt',
        readOnly: true,
      },
      {
        key: 'updatedAt',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'user.updatedAt',
        readOnly: true,
      },
      {
        key: 'deletedAt',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'user.deletedAt',
        readOnly: true,
      },
      {
        key: 'companyId',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'user.companyId',
        readOnly: true,
      },
      {
        key: 'externalId',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'user.externalId',
      },
      {
        key: 'status',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'user.status',
        options: ['inactive', 'active'],
      },
      {
        key: 'type',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'user.type',
        options: ['borrower', 'agent', 'service'],
      },
      {
        key: 'roleIds',
        type: 'array',
        required: false,
        component: 'ArrayEditor',
        fullPath: 'user.roleIds',
        nested: [
          {
            key: '0',
            type: 'string',
            required: true,
            component: 'TextInput',
            fullPath: 'user.roleIds[0]',
          },
        ],
      },
      {
        key: 'userId',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'user.userId',
        numberFormat: 'integer',
      },
      {
        key: 'userName',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'user.userName',
        readOnly: true,
      },
      {
        key: 'auths',
        type: 'array',
        required: false,
        component: 'ArrayEditor',
        fullPath: 'user.auths',
        nested: [
          {
            key: '0',
            type: 'object',
            required: true,
            component: 'TextInput',
            fullPath: 'user.auths[0]',
            nested: [
              {
                key: 'authType',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'user.auths[0].authType',
                options: [
                  'basic',
                  'google',
                  'oneTimeCodeEmail',
                  'oneTimeCodeText',
                  'SAML',
                ],
              },
              {
                key: 'authValueType',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'user.auths[0].authValueType',
                options: ['email', 'username', 'phone', 'samlSubjectNameId'],
              },
              {
                key: 'value',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'user.auths[0].value',
              },
            ],
            readOnly: true,
          },
        ],
        readOnly: true,
      },
    ],
    readOnly: true,
  },
  {
    key: 'userId',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'userId',
  },
  {
    key: 'availableAndPermittedTasktypes',
    type: 'array',
    required: false,
    component: 'ArrayEditor',
    fullPath: 'availableAndPermittedTasktypes',
    nested: [
      {
        key: '0',
        type: 'enum',
        required: true,
        component: 'Select',
        fullPath: 'availableAndPermittedTasktypes[0]',
        options: [
          'answerInboundVoiceCall',
          'handleInboundInteraction',
          'handleUnboundInboundInteraction',
          'makeScheduledCall',
          'replyToNewConvo',
          'replyToNewText',
          'replyToNewWebChat',
          'replyToAbandonedWebChat',
          'reviewEscalatedCaseAgent',
          'reviewEscalatedCaseAgentUrgent',
          'reviewEscalatedCaseTeam',
          'reviewEscalatedCaseTeamUrgent',
          'reviewDocumentUpload',
          'reviewSnoozedCase',
          'reviewAutoCreatedCase',
          'reviewAutoUpdatedCase',
          'reviewCaseInstructions',
          'reviewVoicemail',
          'smartReviewCase',
        ],
      },
    ],
    readOnly: true,
  },
  {
    key: 'managerEmployeeId',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'managerEmployeeId',
  },
  {
    key: 'jobName',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'jobName',
  },
  {
    key: 'email',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'email',
  },
  {
    key: 'displayName',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'displayName',
    readOnly: true,
  },
  {
    key: 'phone',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'phone',
  },
  {
    key: 'externalId',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'externalId',
  },
  {
    key: 'teams',
    type: 'array',
    required: false,
    component: 'ArrayEditor',
    fullPath: 'teams',
    nested: [
      {
        key: '0',
        type: 'object',
        required: true,
        component: 'TextInput',
        fullPath: 'teams[0]',
        nested: [
          {
            key: 'name',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'teams[0].name',
          },
          {
            key: 'id',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'teams[0].id',
            readOnly: true,
          },
          {
            key: 'externalId',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'teams[0].externalId',
          },
          {
            key: 'email',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'teams[0].email',
          },
          {
            key: 'employeeCount',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'teams[0].employeeCount',
            numberFormat: 'integer',
            readOnly: true,
          },
        ],
      },
    ],
  },
  {
    key: 'assignedInvestorIds',
    type: 'array',
    required: false,
    component: 'ArrayEditor',
    fullPath: 'assignedInvestorIds',
    nested: [
      {
        key: '0',
        type: 'string',
        required: true,
        component: 'TextInput',
        fullPath: 'assignedInvestorIds[0]',
      },
    ],
    readOnly: true,
  },
] as const

export const getFieldSchema = (path: string): StaticFieldSchema | undefined => {
  const findByPath = (
    fields: Array<StaticFieldSchema>,
    targetPath: string,
  ): StaticFieldSchema | undefined => {
    for (const field of fields) {
      if (field.fullPath === targetPath) {
        return field
      }
      if (field.nested) {
        const found = findByPath(field.nested, targetPath)
        if (found) return found
      }
    }
    return undefined
  }

  return findByPath(employeesUpdateRequestSchema, path)
}

export const getAllPaths = (): Array<string> => {
  const extractPaths = (fields: Array<StaticFieldSchema>): Array<string> => {
    const paths: Array<string> = []
    for (const field of fields) {
      if (field.fullPath) {
        paths.push(field.fullPath)
      }
      if (field.nested) {
        paths.push(...extractPaths(field.nested))
      }
    }
    return paths
  }

  return extractPaths(employeesUpdateRequestSchema)
}
